export default {
  text: 'You are back online',
};
